import "react-international-phone/style.css";
import {
  InputAdornment,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import React from "react";
import {
  defaultCountries,
  FlagImage,
  parseCountry,
  usePhoneInput,
} from "react-international-phone";

const UIPhoneNumber = ({
  value = "",
  onChange = () => {},
  fieldLabel = "",
  label = "Phone Number",
  required = false,
  disableDropdown = false,
  fullWidth = false,
  size = "small",
  error = false,
  sx = {},
  ...restProps
}) => {
  const { inputValue, handlePhoneValueChange, inputRef, country, setCountry } =
    usePhoneInput({
      defaultCountry: "us",
      value,
      countries: defaultCountries,
      onChange: (data) => {
        onChange(data.phone);
      },
    });

  return (
    <>
      {fieldLabel && (
        <div className="fxs" style={{ marginBottom: "5px", fontWeight: 500 }}>
          {fieldLabel}
          {required && (
            <span style={{ color: "red", marginLeft: "4px" }}>*</span>
          )}
        </div>
      )}

      <TextField
        // Pass all standard TextField props
        fullWidth={fullWidth}
        size={size}
        error={error}
        sx={sx}
        variant="outlined"
        color="primary"
        label={fieldLabel ? "" : label}
        placeholder="Phone number"
        type="tel"
        value={inputValue}
        onChange={handlePhoneValueChange}
        inputRef={inputRef}
        {...restProps}
        InputProps={{
          startAdornment: (
            <InputAdornment
              position="start"
              style={{ marginRight: "2px", marginLeft: "-8px" }}
            >
              <Select
                // Implement the disableDropdown prop
                disabled={disableDropdown}
                MenuProps={{
                  style: {
                    height: "300px",
                    width: "360px",
                    top: "10px",
                    left: "-34px",
                    zIndex: 1500,
                  },
                  transformOrigin: {
                    vertical: "top",
                    horizontal: "left",
                  },
                }}
                sx={{
                  width: "max-content",
                  fieldset: { display: "none" },
                  '&.Mui-focused:has(div[aria-expanded="false"])': {
                    fieldset: { display: "block" },
                  },
                  ".MuiSelect-select": {
                    padding: "8px",
                    paddingRight: "24px !important",
                  },
                  // Target the notched outline class and remove its border
                  "& .MuiOutlinedInput-notchedOutline": {
                    border: "none",
                  },
                  // Ensure the border doesn't reappear on focus
                  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                    border: "none",
                  },
                  svg: { right: 0 },
                }}
                value={country.iso2}
                onChange={(e) => setCountry(e.target.value)}
                renderValue={(value) => (
                  <FlagImage iso2={value} style={{ display: "flex" }} />
                )}
              >
                {defaultCountries.map((c) => {
                  const countryItem = parseCountry(c);
                  return (
                    <MenuItem key={countryItem.iso2} value={countryItem.iso2}>
                      <FlagImage
                        iso2={countryItem.iso2}
                        style={{ marginRight: "8px" }}
                      />
                      <Typography marginRight="8px">
                        {countryItem.name}
                      </Typography>
                      <Typography color="gray">
                        +{countryItem.dialCode}
                      </Typography>
                    </MenuItem>
                  );
                })}
              </Select>
            </InputAdornment>
          ),
        }}
      />
    </>
  );
};

export default UIPhoneNumber;
